
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid2";
import MaterialButton from "../../components/MaterialButton";
import MaterialInput from "../../components/MaterialInput";
import MaterialBox from "../../components/MaterialBox";
import MaterialTypography from "../../components/MaterialTypography";
import { Typography } from "@mui/material";

const ReusableFilter = ({
  open,
  onClose,
  onSave,
  title,
  data,
  dispatch,
  children,
}) => {
  const handleSave = () => {
    onSave();
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      PaperProps={{
        sx: {
          padding: "2%",
          width: "30%",
          height: "100%",
        },
      }}
    >
      <Typography variant="h5" fontWeight="bold">
        {title}
      </Typography>
      <MaterialBox>
        <Grid container spacing={2}>
          {/* Default Date Range Fields */}
          <Grid size={{ xs: 12, sm: 12 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                From Date <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              type="date"
              name="fromDate"
              value={data?.fromDate}
              onChange={(e) => {
                const inputDate = e.target.value;
                const today = new Date().toISOString().split("T")[0];

                // Check if inputDate is not in the future
                if (inputDate <= today) {
                  dispatch({ value: inputDate, name: "fromDate" });
                }
                // Optionally, you can show an error or ignore invalid input
              }}
              inputProps={{
                max: new Date().toISOString().split("T")[0], // max today
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 12 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                To Date <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              type="date"
              name="toDate"
              value={data?.toDate}
              onChange={(e) => {
                const inputDate = e.target.value;
                const today = new Date().toISOString().split("T")[0];
                const minDate = data?.fromDate;

                // Allow only if toDate is between fromDate and today
                if (inputDate <= today && (!minDate || inputDate >= minDate)) {
                  dispatch({ value: inputDate, name: "toDate" });
                }
              }}
              inputProps={{
                max: new Date().toISOString().split("T")[0], // max today
                min: data.fromDate || undefined, // min fromDate
              }}
            />
          </Grid>

          {/* Custom Children */}
          {children}

          <Grid
            size={{ xs: 12, sm: 12 }}
            display="flex"
            justifyContent="space-around"
            alignItems="center"
          >
            <MaterialButton variant="gradient" color="secondary" onClick={onClose}>
              Cancel
            </MaterialButton>
            <MaterialButton
              disabled={!data?.toDate || !data?.fromDate}
              onClick={handleSave}
              variant="gradient"
              color="dark"
            >
              Submit
            </MaterialButton>
          </Grid>
        </Grid>
      </MaterialBox>
    </Drawer>
  );
};

export default ReusableFilter;
